var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"terms"},[_c('div',{staticClass:"terms_title"},[_vm._v(_vm._s(_vm.$t('bookOrder.termsTitle')))]),_c('div',{staticClass:"terms_main",domProps:{"innerHTML":_vm._s(_vm.$store.state.baseConfig.baseConfigInfo.termsAndConditions)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }